import { deviceClass, type DeviceClass } from "@salon-pos/shared";
import { useEffect, useState } from "react";
import { isNativeRuntime, nativePlatform } from "./platform";

/**
 * (Task Z) Phone / tablet / desktop of THIS device (cashier accounts need a tablet). By device class, not orientation:
 * Capacitor Device info (model "iPad…") when the plugin is in the app, the smallest screen side (>= 600 dp = tablet,
 * Android's sw600dp rule — also what MainActivity uses for the landscape lock) and iPadOS-as-Mac detection.
 */
let model: string | null = null;
let loaded = false;
async function loadModel() {
  if (loaded) return;
  loaded = true;
  if (!isNativeRuntime()) return;
  try {
    const cap = (window as unknown as { Capacitor?: { isPluginAvailable?: (n: string) => boolean } }).Capacitor;
    if (!cap?.isPluginAvailable?.("Device")) return; // native app older than 0.4.0: screen size + UA only
    const { Device } = await import("@capacitor/device");
    model = (await Device.getInfo()).model ?? null;
  } catch { /* screen size + UA */ }
}
export function currentDeviceClass(): DeviceClass {
  if (typeof window === "undefined") return "desktop";
  return deviceClass({ platform: isNativeRuntime() ? nativePlatform() : "web", model, userAgent: navigator.userAgent, screenW: window.screen?.width || window.innerWidth,
    screenH: window.screen?.height || window.innerHeight, maxTouchPoints: navigator.maxTouchPoints ?? 0 });
}
export function useDeviceClass(): DeviceClass {
  const [c, setC] = useState<DeviceClass>(() => currentDeviceClass());
  useEffect(() => {
    let alive = true;
    void loadModel().then(() => { if (alive) setC(currentDeviceClass()); });
    const on = () => setC(currentDeviceClass());
    window.addEventListener("resize", on);
    return () => { alive = false; window.removeEventListener("resize", on); };
  }, []);
  return c;
}
